<template>
    <div class="flex shrink-0 items-center gap-2">
        <BaseButton variant="ghost" :size="buttonSize" @click="$emit('cancel')">
            {{ localizations[lang].cancel }}
        </BaseButton>
        <BaseButton
            v-if="shouldShowSave"
            variant="primary"
            :class="saveButtonWidthClass"
            :size="buttonSize"
            :disabled="isSaveDisabled"
            :dusk="saveDusk"
            :data-role="saveDataRole"
            @click="$emit('save')"
        >
            {{ saveLabel }}
        </BaseButton>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseButton from './BaseButton.vue';

/** The Cancel/Save pair that commits a form. */
export default {
    name: 'CommitActions',

    components: {
        BaseButton,
    },

    props: {
        saveLabel: {
            type: String,
            required: true,
        },
        isSaveDisabled: {
            type: Boolean,
            default: false,
        },
        shouldShowSave: {
            type: Boolean,
            default: true,
        },
        /** Test hooks for the Save button, in whichever convention the host already uses. */
        saveDusk: {
            type: String,
            default: null,
        },
        saveDataRole: {
            type: String,
            default: null,
        },
    },

    emits: ['cancel', 'save'],

    computed: {
        ...mapState(['localizations', 'lang']),
        ...mapGetters(['onlyMobileVisible']),

        /**
         * Tighter buttons on a phone, where the row has the least room.
         * @returns {'sm'|'md'}
         */
        buttonSize() {
            return this.onlyMobileVisible ? 'sm' : 'md';
        },

        /**
         * Floor the Save button's width so its label never wraps mid-word.
         * @returns {string}
         */
        saveButtonWidthClass() {
            return this.onlyMobileVisible ? 'min-w-[60px]' : 'min-w-[88px]';
        },
    },
};
</script>
